import MobileFeatureModal from 'components/MobileFeatureModal';
import type { ReactNode } from 'react';

// https://www.figma.com/file/adkZqjUnPR59F9VjwVxexg/App-Download-QR-Code

type Props = {
  className?: string;
  isOpen: boolean;
  onRequestClose: () => void;
  qrCode: string;
  subtitleDesktop?: ReactNode;
  subtitleMobile?: ReactNode;
  title: ReactNode;
  variant?: 'navigator' | 'explore';
};

const AppQrCodeModal = ({ className, isOpen, onRequestClose, qrCode, subtitleDesktop, subtitleMobile, title, variant = 'navigator' }: Props) => (
  <MobileFeatureModal
    className={className}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    qrCodeImgSrc={qrCode}
    subtitleMobile={subtitleMobile}
    subtitleDesktop={subtitleDesktop}
    title={title}
    variant={variant}
  />
);

export default AppQrCodeModal;
